@if (rendering && stats$ | async; as stats) {
  <wl-review-score
    [title]="rendering?.fields?.Title"
    [button]="rendering?.fields?.ButtonLink"
    [stats]="stats"
    type="small"
    trackImpression="contentblock-impression"
    [trackImpressionInfo]="rendering"
    [trackImpressionContext]="context"
  ></wl-review-score>
}
